import { PDFDocument, PDFFont, StandardFonts } from 'pdf-lib'
import fontkit from '@pdf-lib/fontkit'
import { CustomFont } from './types'

// TODO: Need a font CDN to serve up these assets instead of having them all stored in public,
// this could also make it easier to do bolding and everything else. It might also be worth figuring out
// if I can use google font cdn directly saving effort of hosting my own
export const fontMap: Record<CustomFont, string> = {
  amaticSC: '/fonts/amaticSC/AmaticSC-Regular.ttf',
  domine: '/fonts/domine/static/Domine-Regular.ttf',
  greatVibes: '/fonts/greatVibes/GreatVibes-Regular.ttf',
  lato: '/fonts/lato/Lato-Regular.ttf',
  lobster: '/fonts/lobster/Lobster-Regular.ttf',
  montserrat: '/fonts/montserrat/static/Montserrat-Regular.ttf',
  monument: '/fonts/monument/MonumentValley.otf',
  openSans: '/fonts/openSans/static/OpenSans-Regular.ttf',
  oswald: '/fonts/oswald/static/Oswald-Regular.ttf',
  playfairDisplay: '/fonts/playfairDisplay/static/PlayfairDisplay-Regular.ttf',
  plusJakartaSans: '/fonts/plusJakartaSans/static/PlusJakartaSans-Regular.ttf',
  poppins: '/fonts/poppins/Poppins-Regular.ttf',
  quicksand: '/fonts/quicksand/static/Quicksand-Regular.ttf',
  raleway: '/fonts/raleway/static/Raleway-Regular.ttf',
  righteous: '/fonts/righteous/Righteous-Regular.ttf',
  roboto: '/fonts/roboto/Roboto-Regular.ttf',
  sacramento: '/fonts/sacramento/Sacramento-Regular.ttf',
}

export async function embedFont(
  pdf: PDFDocument,
  custom?: CustomFont,
  standard?: StandardFonts,
): Promise<PDFFont> {
  if (standard) {
    console.log('Embedding standard')
    return await pdf.embedFont(standard)
  }
  if (custom) {
    console.log('Embedding custom', custom)
    pdf.registerFontkit(fontkit)
    const fontBuffer = await getCustomFont(custom)
    const fontk = fontkit.create(new Uint8Array(fontBuffer))
    console.log('****embedded font****', fontk)
    return await pdf.embedFont(fontBuffer)
  }
  throw new Error('Need either standard or custom font')
}

async function getCustomFont(selection: CustomFont): Promise<ArrayBuffer> {
  const custom = fontMap[selection]
  console.log('custom', custom)
  const font = await fetch(custom)
  console.log('FONT URL', font)
  return await font.arrayBuffer()
}
